import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useSmScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";

interface EmailDisplayBoxProps {
  email: string;
  onClose: () => void;
}

export const EmailDisplayBox = ({ email, onClose }: EmailDisplayBoxProps) => {
  const isSmScreen = useSmScreenMediaQuery();

  return (
    <div className="bg-secondary flex items-center justify-between rounded-t-xl py-[13px]">
      <Typography.BodySm weight="normal" size="text-base">
        {email}
      </Typography.BodySm>
      <Button
        type="button"
        variant="tertiary"
        onClick={onClose}
        className="rounded-full !p-1"
      >
        <Icon
          type={isSmScreen ? "24-close" : "20-close"}
          size={isSmScreen ? 24 : 20}
          className={classNames({
            "!text-dark": isSmScreen,
            "text-primary": !isSmScreen,
          })}
        />
      </Button>
    </div>
  );
};
